<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @change="(val) => $emit('update:is-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="
          d-flex
          justify-content-between
          align-items-center
          content-sidebar-header
          px-2
          py-1
        "
      >
        <h5 class="mb-0">
          {{ Object.entries(data).length === 0 ? $t("Add New") : $t("Update") }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>
      <!-- Form -->
      <validation-observer ref="formData">
        <b-form class="p-2">
          <b-row>
            <b-col cols="12">
              <b-form-group
                :label="$t('Image')"
                label-for="register-image"
              >
                <!-- media -->
                <b-media no-body>
                  <b-media-aside>
                    <b-link>
                      <b-img
                        v-if="image"
                        ref="previewEl"
                        rounded
                        :src="image"
                        height="80"
                      />
                      <b-img
                        v-else
                        ref="previewEl"
                        :src="require('@/assets/images/blank/no_image.png')"
                        rounded
                        height="80"
                      />
                    </b-link>
                    <!--/ avatar -->
                  </b-media-aside>

                  <b-media-body class="mt-75 ml-75">
                    <!-- upload button -->
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="primary"
                      size="sm"
                      class="mb-75 mr-75"
                      @click="$refs.refInputEl.$el.click()"
                    >
                      {{ $t("Upload") }}
                    </b-button>
                    <b-form-file
                      ref="refInputEl"
                      accept=".webp, .jpeg, .jpg, .png, .gif"
                      :hidden="true"
                      plain
                      @change="inputImageRenderer"
                    />
                    <!--/ upload button -->

                    <!-- reset -->
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      size="sm"
                      class="mb-75 mr-75"
                      @click="resetImage"
                    >
                      {{ $t("Reset") }}
                    </b-button>
                    <!--/ reset -->
                    <b-card-text>{{ $t('Allowed') }} JPG, GIF {{ $t('or') }} PNG. {{ $t('Max size of') }} 300KB</b-card-text>
                  </b-media-body>
                </b-media>
                <!--/ media -->
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <!-- firstName -->
              <b-form-group
                :label="$t('Name')"
                label-for="register-name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Name"
                  vid="name"
                  rules="required"
                >
                  <b-form-input
                    id="register-name"
                    v-model="name"
                    name="register-name"
                    :state="errors.length > 0 ? false:null"
                    :placeholder="$t('Name')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                :label="$t('Action Click')"
                label-for="register-actionClick"
              >
                <validation-provider
                  #default="{ errors }"
                  name="actionClick"
                  vid="actionClick"
                  rules="required"
                >
                  <v-select
                    id="register-actionClick"
                    v-model="actionClick"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="OptionActionClick"
                    :reduce="(OptionActionClick) => OptionActionClick.value"
                    :clearable="false"
                    class="select-size-lg"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider></b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                :label="$t('Partner profile')"
                label-for="register-profilePartner"
              >
                <v-select
                  id="register-respDataProfilePartner"
                  v-model="profilePartnerId"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="firstName"
                  :options="respDataProfilePartner"
                  :reduce="(respDataProfilePartner) => respDataProfilePartner._id"
                  :filterable="false"
                  class="select-size-lg"
                  @search="onSearchPartner"
                >
                  <div
                    slot="list-footer"
                    class="m-1"
                  >
                    <b-row>
                      <b-col cols="4">
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="info"
                          block
                          :disabled="currentPageProfilePartner <= 1 ? true :false"
                          @click="nextPagePartner(currentPageProfilePartner -1)"
                        >
                          <feather-icon
                            icon="ChevronLeftIcon"
                            size="18"
                          />
                        </b-button>
                      </b-col>
                      <b-col cols="4">
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          block
                          disabled
                        >
                          {{ currentPageProfilePartner }}
                        </b-button>
                      </b-col>
                      <b-col cols="4">
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="info"
                          block
                          :disabled="(currentPageProfilePartner * perPageProfilePartner) >= queriedItemsPartner ? true :false"
                          @click="nextPagePartner(currentPageProfilePartner + 1)"
                        >
                          <feather-icon
                            icon="ChevronRightIcon"
                            size="18"
                          />
                        </b-button>
                      </b-col>
                    </b-row>

                  </div>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                :label="$t('Service Area')"
                label-for="register-serviceArea"
              >
                <validation-provider
                  #default="{ errors }"
                  name="serviceArea"
                  vid="serviceArea"
                  rules=""
                >
                  <v-select
                    id="register-serviceArea"
                    v-model="serviceAreaId"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="serviceAreaData"
                    :reduce="(serviceAreaData) => serviceAreaData._id"
                    class="select-size-lg"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider></b-form-group>
            </b-col>
            <b-col cols="12">
              <!-- firstName -->
              <b-form-group
                :label="$t('Link')"
                label-for="register-link"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Link"
                  vid="link"
                  rules=""
                >
                  <b-form-input
                    id="register-link"
                    v-model="link"
                    name="register-link"
                    :state="errors.length > 0 ? false:null"
                    :placeholder="$t('Link')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                :label="$t('Start Date')"
                label-for="start-date"
              >
                <validation-provider
                  #default="{ errors }"
                  name="StartDate"
                  vid="startDate"
                  rules="required"
                >
                  <flat-pickr
                    v-model="startDate"
                    class="form-control"
                    :config="configs"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12">

              <b-form-group
                :label="$t('Expire Date')"
                label-for="expire-date"
              >
                <validation-provider
                  #default="{ errors }"
                  name="ExpireDate"
                  vid="expireDate"
                  rules="required"
                >
                  <flat-pickr
                    v-model="expireDate"
                    class="form-control"
                    :config="configs"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

          </b-row>
          <!-- Action button -->
          <div class="d-flex mt-2">
            <b-button
              variant="primary"
              class="mr-2"
              @click="validationForm()"
            >
              {{ $t("Submit") }}
            </b-button>
            <b-button
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              {{ $t("Cancel") }}
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BSidebar,
  BButton,
  BFormFile,
  BMedia,
  // BMediaAside,
  BMediaBody,
  // BLink,
  BImg,
  BCardText,
  BInputGroupAppend,
  BInputGroup,
  BFormInput,
  BForm,
  BFormGroup,
  BRow,
  BCol,
  BLink,
  BMediaAside,
} from 'bootstrap-vue'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'

import vSelect from 'vue-select'
import store from '@/store'

// eslint-disable-next-line import/extensions
import { Thai } from 'flatpickr/dist/l10n/th.js'

export default {
  components: {
    flatPickr,
    BSidebar,
    BButton,
    BFormFile,
    BMedia,
    // BMediaAside,
    BMediaBody,
    // BLink,
    BImg,
    BCardText,
    BForm,
    BFormInput,
    BFormGroup,
    // eslint-disable-next-line vue/no-unused-components
    BInputGroupAppend,
    // eslint-disable-next-line vue/no-unused-components
    BInputGroup,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BLink,
    BMediaAside,
    vSelect,
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  model: {
    prop: 'isSidebarActive',
    event: 'update:is-sidebar-active',
  },
  props: {
    storeModuleName: {
      type: String,
      required: true,
    },
    storeModuleNameServiceArea: {
      type: String,
      required: true,
    },
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
    show: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      searchProfilePartner: '',
      currentPageProfilePartner: 1,
      perPageProfilePartner: 10,
      dataId: null,
      image: '',
      name: '',
      actionClick: '',
      html: [],
      link: '',
      profilePartnerId: null,
      serviceAreaId: null,
      startDate: '',
      expireDate: '',
      configs: {
        enableTime: false,
        dateFormat: 'd-m-Y',
        locale: Thai,
      },
      required,
    }
  },
  computed: {
    OptionActionClick() {
      return [
        { name: this.$t('open_profile_partner'.toUpperCase()), value: 'open_profile_partner' },
        { name: this.$t('open_html'.toUpperCase()), value: 'open_html' },
        { name: this.$t('open_link'.toUpperCase()), value: 'open_link' },
      ]
    },
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    language() {
      return store.state.appConfig.systemConfig ? store.state.appConfig.systemConfig.language : []
    },
    serviceAreaData() {
      return store.state[this.storeModuleNameServiceArea].respData != null ? store.state[this.storeModuleNameServiceArea].respData.data : []
    },
    respDataProfilePartner() {
      return store.state[this.storeModuleName].respDataProfilePartner != null ? store.state[this.storeModuleName].respDataProfilePartner.data : []
    },
    queriedItemsPartner() {
      return store.state[this.storeModuleName].respDataProfilePartner != null ? store.state[this.storeModuleName].respDataProfilePartner.max : 0
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.getProfilePartner()
        if (Object.entries(this.data).length === 0) {
          this.$refs.formData.reset()
          this.initValues()
          if (this.html.length !== this.language.length) {
            for (let index = 0; index < this.language.length; index += 1) {
              const indexLanguage = this.html.findIndex(element => element.lang === this.language[index].lang)
              if (indexLanguage < 0) {
                this.html.push({
                  lang: this.language[index].lang, // th , en
                  value: '',
                })
              }
            }
          }
        } else {
          const {
            _id,
            image,
            name,
            actionClick,
            html,
            link,
            profilePartnerId,
            serviceAreaId,
            startDate,
            expireDate,
          } = this.data
          this.dataId = _id
          this.image = image
          this.name = name
          this.actionClick = actionClick
          this.html = html
          this.link = link
          this.profilePartnerId = profilePartnerId
          this.serviceAreaId = serviceAreaId
          this.startDate = startDate
          this.expireDate = expireDate
          if (this.html.length !== this.language.length) {
            for (let index = 0; index < this.language.length; index += 1) {
              const indexLanguage = this.html.findIndex(element => element.lang === this.language[index].lang)
              if (indexLanguage < 0) {
                this.html.push({
                  lang: this.language[index].lang, // th , en
                  value: '',
                })
              }
            }
            for (let index = 0; index < this.html.length; index += 1) {
              const indexLanguage = this.language.findIndex(element => element.lang === this.html[index].lang)
              if (indexLanguage < 0) {
                this.html.splice(index, 1)
              }
            }
          }
        }
      }
    },
  },
  methods: {
    getProfilePartner() {
      const objPartner = {
        currentPage: this.currentPageProfilePartner,
        pageSize: this.perPageProfilePartner,
        searchQuery: this.searchProfilePartner,
      }
      store
        .dispatch(`${this.storeModuleName}/getProfilePartner`, objPartner)
      // eslint-disable-next-line no-unused-vars
        .then(result => {
        // console.log('fetch Success : ', result)
        // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
          // eslint-disable-next-line no-unused-vars
        }).catch(error => {
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
        // console.log('fetchUsers Error : ', error)
        // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    onSearchPartner(query) {
      this.searchProfilePartner = query
      this.currentPageProfilePartner = 1
      const obj = {
        currentPage: this.currentPageProfilePartner,
        pageSize: this.perPageProfilePartner,
        searchQuery: this.searchProfilePartner,
      }
      store
        .dispatch(`${this.storeModuleName}/getProfilePartner`, obj)
        .then(result => {
          console.log('fetch Success : ', result)
        // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        }).catch(error => {
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
        // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, '0')
    },
    formatDate(date) {
      return [
        this.padTo2Digits(date.getDate()),
        this.padTo2Digits(date.getMonth() + 1),
        date.getFullYear(),
      ].join('-')
    },
    inputImageRenderer(input) {
      // eslint-disable-next-line prefer-destructuring
      if (input.target.files && input.target.files[0]) {
        if (input.target.files[0].size > 300000) {
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: `${this.$t('Allowed')} JPG, GIF ${this.$t('or')} PNG. ${this.$t('Max size of')} 300KB`,
            },
          })
          return
        }

        const reader = new FileReader()
        reader.onload = e => {
          this.image = e.target.result
          // const obj = { image: e.target.result }
          // this.$store
          //   .dispatch(`${this.storeModuleName}/uploadImage`, obj)
          //   .then(resp => {
          //     console.log(resp)
          //     this.image = resp.data.data.url
          //   })
          //   .catch(err => {
          //     console.error(err)
          //   })
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    resetImage() {
      this.image = ''
    },
    initValues() {
      this.dataId = null
      this.image = ''
      this.name = ''
      this.actionClick = ''
      this.html = []
      this.link = ''
      this.serviceAreaId = null
      this.profilePartnerId = null
      this.startDate = ''
      this.expireDate = ''
      // this.$refs.refInputEl.reset()
    },
    validationForm() {
      this.$refs.formData.validate().then(success => {
        if (success) {
          const startDate = this.startDate.split('-')
          const expireDate = this.expireDate.split('-')
          const obj = {
            id: this.dataId,
            image: this.image,
            name: this.name,
            html: this.html,
            link: this.link,
            actionClick: this.actionClick,
            serviceArea: this.serviceAreaId,
            profilePartnerId: this.profilePartnerId,
            // eslint-disable-next-line radix
            startDate: this.formatDate(new Date(parseInt(startDate[2]), parseInt(startDate[1]) - 1, parseInt(startDate[0]))),
            // eslint-disable-next-line radix
            expireDate: this.formatDate(new Date(parseInt(expireDate[2]), parseInt(expireDate[1]) - 1, parseInt(expireDate[0]))),
          }
          this.$emit('update:show', true)
          if (this.dataId !== null) {
            store
              .dispatch(`${this.storeModuleName}/update`, obj)
              .then(result => {
                this.$emit('update:is-sidebar-active', false)
                this.$emit('update:show', false)
                console.log('fetch Success : ', result)
                // this.showToast('success', 'bottom-right')
              })
              .catch(error => {
                console.log('fetchUsers Error : ', error)
                this.$toast({
                  component: ToastificationContent,
                  position: 'bottom-right',
                  props: {
                    title: this.$t('Error'),
                    icon: 'ErrorIcon',
                    variant: 'danger',
                    text: this.$t(error.response.data.message),
                  },
                })
                this.$emit('update:show', false)
                // this.showToast('danger', 'bottom-right')
              })
          } else {
            delete obj.id
            store
              .dispatch(`${this.storeModuleName}/add`, obj)
              .then(result => {
                this.$emit('update:is-sidebar-active', false)
                this.$emit('update:show', false)
                console.log('fetch Success : ', result)
                // this.showToast('success', 'bottom-right')
              })
              .catch(error => {
                console.log('fetchUsers Error : ', error)
                this.$toast({
                  component: ToastificationContent,
                  position: 'bottom-right',
                  props: {
                    title: this.$t('Error'),
                    icon: 'ErrorIcon',
                    variant: 'danger',
                    text: this.$t(error.response.data.message),
                  },
                })
                this.$emit('update:show', false)
                // this.showToast('danger', 'bottom-right')
              })
          }
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}

.btn-remove {
  position: absolute;
  top: 20%;
  left: 30%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: red;
  color: white;
  font-size: 12px;
  padding: 12px 16px;
  border: none;
  cursor: pointer;
  border-radius: 15px;
  text-align: center;
}
.imgs-show {
  // width: 100%;
  height: 100px;
}
</style>
